module.exports = __webpack_public_path__ + "img/pump-square.e8c9fd89.svg";